import {
  httpGet,
  getAuthHeaders,
} from "../utils/http";

export default class {
  apiEndpoint = null;

  constructor(apiEndpoint) {
    this.apiEndpoint = apiEndpoint;
  }

  exportSupplierList() {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/supplier/export`;
    return httpGet(apiUrl, {
      responseType: 'arraybuffer',
      ...getAuthHeaders(),
    });
  }
}
